import { createFileRoute } from "@tanstack/react-router";
import { AskPanel } from "@/components/ask/AskPanel";

export const Route = createFileRoute("/_authenticated/ask")({
  head: () => ({
    meta: [
      { title: "Assistant workspace · Oxley" },
      { name: "description", content: "Ask open questions about your catalog and approvals in a full-page conversation." },
      { property: "og:title", content: "Assistant workspace · Oxley" },
      { property: "og:description", content: "Ask open questions about your catalog and approvals in a full-page conversation." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <div className="mx-auto w-full"><AskPanel fullPage /></div>,
});
